import React from 'react';
import FooterComponent from './footer.component';

const FooterContainer: React.FC = () => {
  const url = process.env.REACT_APP_LANDING_URL;
  return <FooterComponent logoGoTo={`${url}`} />;
};

export default FooterContainer;
